import React from 'react';

const IntroPisoDeckSintetico = () => {
  return (
    <section className="pb-xxl-20">
      <div className="container">
        <div className="row align-items-center">
          {/* Columna de texto */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="mb-1-9 mb-lg-2-5 title-style5">
              <span className="sub-title">Elegancia y Durabilidad para tus Proyectos</span>
              <h2 className="display-5 lh-1 font-weight-800 mb-0">
                Piso Deck Sintético
              </h2>
            </div>
            <div className="mb-5">
            <p className="mb-1-6 mb-sm-2-2">
            El piso deck sintético se ha consolidado como la solución ideal para quienes buscan combinar estética y funcionalidad en espacios interiores y exteriores. <br></br>
            Fabricado a partir de compuestos sintéticos de alta calidad, este material ofrece la apariencia de la madera natural, pero con ventajas superiores en términos de resistencia y mantenimiento.
            </p>

              {/* Tarjetas */}
              <Tarjeta
                titulo="Resistencia al agua y a la humedad"
                descripcion="Es perfecto para áreas en interiores y expuestas a la intemperie."
                delay="200ms"
              />
              <Tarjeta
                titulo="Durabilidad "
                descripcion="No pierde su integridad estructural ni su atractivo estético."
                delay="400ms"
              />
              <Tarjeta
                titulo="Estética Moderna"
                descripcion="Se adapta a las tendencias actuales en arquitectura y diseño de interiores."
                delay="600ms"
              />
              <Tarjeta
                titulo="Fácil Mantenimiento"
                descripcion="A diferencia de la madera no requiere tratamientos periódicos."
                delay="600ms"
              />
            </div>
            <a
              href="contacto-decototal"
              className="butn-style7 rounded wow fadeInUp"
              data-wow-delay="400ms"
            >
              Cotiza Ahora
            </a>
          </div>
          {/* Columna de imagen */}
          <div className="col-lg-6 order-1 order-lg-2 mb-1-9 mb-lg-0">
            <div className="extra-style-01">
              <img
                className="rounded"
                src="/assets/img/productos/piso-deck-sintetico/piso-deck-sintetico-intro.jpg"
                alt="pisos spc oficina"
              />
              <div className="image-shape1">
                <img
                  className="d-none d-md-block"
                  src="/assets/img/productos/piso-deck-sintetico/piso-deck-sintetico-small.png"
                  alt="pisos spc sala"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Tarjeta = ({ titulo, descripcion, delay }) => {
  return (
    <div className={`card card-style21 border-0 wow fadeInUp`} data-wow-delay={delay}>
      <div className="d-flex">
        <span className="card-icon">
          <i className="fa-solid fa-check"></i>
        </span>
        <div className="card-content">
          <h5 className="card-title">{titulo}</h5>
          <p className="card-disc w-lg-85 w-xl-100">{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default IntroPisoDeckSintetico;

